import { Input } from './styles'
import { InputBoxProps } from './InputBox.types'

export function InputBox({ ...rest }: InputBoxProps): JSX.Element {
  return <Input maxLength={1} {...rest} />
}

export default InputBox
